import styled from 'styled-components'
import {Link} from 'react-router-dom'

// Main Container for the Gaming Route
export const HomeContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  min-height: 100vh;
  background-color: ${props => props.bgColor};
  overflow: hidden;
  transition: background-color 0.3s ease;
`

// Side Container for additional content
export const HomeSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  padding: 20px;
  background-color: ${props => props.bgColor};
  transition: background-color 0.3s ease;

  @media (max-width: 768px) {
    padding: 15px;
  }
`

// Container for the searched videos
export const SearchedVideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.bgColor};
  padding: 30px;
  overflow-y: auto;
  transition: background-color 0.3s ease;

  @media (max-width: 768px) {
    padding: 20px;
  }
`

// Container for the video items
export const VideosContainer = styled.ul`
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* Display 4 cards in a row */
  gap: 20px;
  padding: 0;
  list-style-type: none;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr); /* Adjust to 2 cards in a row on smaller screens */
    gap: 15px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr; /* Adjust to 1 card in a row on very small screens */
  }
`

// Loader Container
export const ProductsLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

// Not Found Container
export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #fff;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 10px;
  }
`

// Image for failure view
export const Image = styled.img`
  width: 300px;
  margin: 20px;
  transition: width 0.3s ease;

  @media (max-width: 768px) {
    width: 250px;
    margin: 15px;
  }
`

// Heading for failure view
export const Heading = styled.h1`
  color: black;
  text-align: center;
  font-size: 30px;
  font-family: 'Roboto', sans-serif;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 26px;
  }
`

// Description text for failure view
export const Desc = styled.p`
  color: black;
  text-align: center;
  font-size: 18px;
  margin: 10px 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

// NavLink styled component
export const NavLink = styled(Link)`
  color: #007bff;
  text-decoration: none;
`

// Retry button styled component
export const Retry = styled.button`
  padding: 10px 20px;
  color: #007bff;
  background-color: transparent;
  border: 2px solid #007bff;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: #007bff;
    color: #fff;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 5px #007bff;
  }
`

// Sticky container for sidebar
export const HomeStickyContainer = styled.div`
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  transition: background-color 0.3s ease;
`
